import React, { Fragment, useContext } from 'react';
import cartQuery from '../../data/queries/CartQuery.gql';
import { CartIdContext } from '../Cart/CartIdContext';
import FlightNostoCart from '../nosto/FlightNostoCart';
import { useQuery } from 'react-apollo-hooks';
import logWarningInDev from '../../helpers/logWarningInDev';
export default function CartProvider({ children, query }) {
    if (!query) {
        logWarningInDev(true, `CartProvider expects a query prop. Not providing one is deprecated and will not work in the next major release. See https://gitlab.jetshop.se/jetshop/flight/blob/master/packages/template-trend/src/components/Cart/CartQuery.gql for a reference implementation.`);
        query = cartQuery;
    }
    const { cartId } = useContext(CartIdContext);
    const result = useQuery(query, {
        ssr: false,
        variables: { cartId }
    });
    if (!result.data || (result.data && !result.data.cart)) {
        result.data = {};
        result.data.cart = null;
    }
    return (React.createElement(Fragment, null,
        result.data && result.data.cart && (React.createElement(FlightNostoCart, { cart: result.data.cart })),
        children(result)));
}
//# sourceMappingURL=CartProvider.js.map